import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";
import { apiCall } from "../base";

export const ProcessList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `ProcessList_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.PROCESSES,
        method: HttpMethod.GET,
      }),
  };
};

export const ProcessesList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `ProccessesList_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.PROCESSES,
        method: HttpMethod.GET,
      }),
  };
};

export const ProcessFieldMetadata = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `ProcessFieldMetadata_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.PROCESS_FIELD_METADATA,
        method: HttpMethod.GET,
      }),
  };
};

export const UpdateProcessField = (
  params: { processId: number; partId: number },
  body: any
) => {
  return apiCall<any>({
    body,
    url: `part/${params.partId}/${ENDPOINT.PROCESS}/${params.processId}/field`,
    method: HttpMethod.PATCH,
  });
};

export const UpdateProcessData = (id: number, body: any) => {
  return apiCall<any>({
    body,
    url: `${ENDPOINT.PROCESS}/${id}`,
    method: HttpMethod.PUT,
  });
};

export const AddProcessData = (body: any) => {
  return apiCall<any>({
    body,
    url: `${ENDPOINT.PROCESS}`,
    method: HttpMethod.POST,
  });
};

export const DeleteProcessData = (id: number) => {
  return apiCall<any>({
    url: `${ENDPOINT.PROCESS}/${id}`,
    method: HttpMethod.DELETE,
  });
};
